export const app = {
  namespaced: true,
  state: {
    appName: 'GroupBot',
    drawer: true,
    accountMenu: false,
    accountRedirect: true,
    secondaryDrawer: false,
    profileDialog: false,
    message: null,
    selectedBot: null
  },
  mutations: {
    drawer(state, set) {
      state.drawer = set
    },
    accountMenu(state, set) {
      state.accountMenu = set
    },
    accountRedirect(state, set) {
      state.accountRedirect = set
    },
    secondaryDrawer(state, set) {
      if (set === 'toggle') {
        state.secondaryDrawer = !state.secondaryDrawer
      } else {
        state.secondaryDrawer = set
      }
    },
    profileDialog(state, set) {
      state.profileDialog = set
    },
    appMessage(state, message) {
      state.message = message
    },
    selectedBot(state, bot) {
      state.selectedBot = bot
    }
  },
  actions: {
    drawerSet({ commit }, set) {
      commit('drawer', set)
    },
    accountMenuSet({ commit }, set) {
      commit('accountMenu', set)
    },
    accountRedirectSet({ commit }, set) {
      commit('accountRedirect', set)
    },
    secondaryDrawerSet({ commit }, set) {
      commit('secondaryDrawer', set)
    },
    profileDialogSet({ commit }, set) {
      commit('profileDialog', set)
    },
    showMessage({ commit }, set) {
      commit('appMessage', set)
    },
    removeMessage({ commit }) {
      commit('appMessage', null)
    },
    selectedBotSet({ commit }, set) {
      commit('selectedBot', set)
    },
  },
  getters: {
    drawer: state => state.drawer,
    accountMenu: state => state.accountMenu,
    accountRedirect: state => state.accountRedirect,
    secondaryDrawer: state => state.secondaryDrawer,
    profileDialog: state => state.profileDialog,
    appMessage: state => state.message,
    selectedBot: state => state.selectedBot,
  }
}